import moment from "moment";
import axios from "axios";

import { Button } from "@/components/ui/button";
import { InputDateGroup } from "@/components/ui/input";
import { apiDomain, getAuthCustomer, optionRole, userToken } from "@/helpers/h";
import { useData } from "@/stores/data";
import { useModal } from "@/stores/modal";
import { useState } from "react";
import { SelectGroup } from "@/components/ui/select";

export default function ExportSOT() {
  const { close } = useModal();
  const { loading, setLoading } = useData();
  const [filter, setFilter] = useState({
    from: moment().startOf("week").format("YYYY-MM-DD"),
    to: moment().endOf("week").format("YYYY-MM-DD"),
    role: [],
  });
  // const { data, isLoading } = useFetch({
  //   url: `/v2/service_order_ticket?withSotForm=1&date_from=${filter?.from}&date_to=${filter?.to}&role=${filter?.role}`,
  //   method: "GET",
  //   condition: filter?.from && filter?.to && filter?.role?.length > 0,
  //   dep: [filter?.from, filter?.to, filter?.role],
  // });
  const handleExport = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        withSotForm: 1,
        export: 1,
        date_from: filter?.from,
        date_to: filter?.to,
        role: filter?.role,
        customer_ids:
          getAuthCustomer().length > 0
            ? getAuthCustomer()
                .map((obj) => obj.id)
                .join(",")
            : "",
      });

      const res = await axios({
        method: "GET",
        responseType: "blob",
        url: `${apiDomain()}/v2/export/sot?${params}`,
        headers: { Authorization: `Bearer ${userToken()}` },
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = `${
        filter.role?.length > 0
          ? filter.role?.length == 1
            ? filter.role.includes("flm")
              ? "flm"
              : filter.role.includes("cit")
                ? "cit"
                : filter.role.includes("cv")
                  ? "cv"
                  : "se"
            : filter.role.join("_")
          : ""
      }_sot_${moment().format("hhmm_DDMMYYYY")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="flex flex-col gap-[20px] bg-white rounded-[8px] md:rounded-[12px] lg:rounded-[16px] p-[24px] max-h-[90dvh] overflow-y-auto overflow-x-hidden">
      <h2 className="font-bold md:w-[500px] text-[24px]">Export SOT</h2>
      <SelectGroup
        menuPosition="fixed"
        isClearable
        isMulti
        isDisabled={!optionRole || loading}
        placeholder="Select Service Assigned Person Type"
        className="w-full"
        options={optionRole}
        value={optionRole.filter((obj) => {
          return filter.role?.includes(obj.value);
        })}
        onChange={(e) => {
          setFilter({
            ...filter,
            role: e?.map((obj) => obj.value) || [],
          });
        }}
      />
      <InputDateGroup
        label="From"
        value={filter?.from || ""}
        disabled={loading}
        onChange={(date) => {
          setFilter({
            ...filter,
            from: date,
          });
        }}
      />
      <InputDateGroup
        label="To"
        value={filter?.to || ""}
        disabled={loading}
        onChange={(date) => {
          setFilter({
            ...filter,
            to: date,
          });
        }}
      />
      <div className="flex gap-2 flex-col md:flex-row gap-3 justify-end">
        <Button variant="gray" onClick={close} isLoading={loading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleExport} isLoading={loading}>
          Export to Excel
        </Button>
      </div>
    </div>
  );
}
